import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunkMiddleware from 'redux-thunk'
import { logger } from 'redux-logger'
import reducers from './reducers'

// eslint-disable-next-line func-names
export default function (initialState = {}) {
  // eslint-disable-next-line max-len
  const middleware = process.env.NODE_ENV === 'development' ? [logger, thunkMiddleware] : [thunkMiddleware]
  const middlewareEnhancer = applyMiddleware(...middleware)
  const enhancers = [middlewareEnhancer]
  const composedEnhancers = composeWithDevTools(...enhancers)
  const store = createStore(reducers, initialState, composedEnhancers)
  return store
}
